import * as React from 'react';
import { Link } from 'react-router-dom';

import {
	SearchValuInclusiveUrl,
	SpecialDealURL,
	CardImages,
	DefaultCardImages,
} from '@app/constants/url.constants';
import {
	ButtonVariant,
	ActionMode,
	Button,
} from '@app/components/Button/Button';
import { PageSection } from '@app/pages/MainPage/ValueInclusive/PageSection';
import { Image } from '@app/components/Image';

import { Package } from '@app/pages/MainPage/ValueInclusive/types';

import batch from '@image/valueinclusive/best-sellers.png';
import calendar from '@image/valueinclusive/calendar.svg';
import location from '@image/valueinclusive/location.svg';

import background from '@image/valueinclusive/background.png';
import fallback from '@image/valueinclusive/fallback.jpg';

interface PackageCardProps {
	item: Package;
}

const PackageCard: React.FC<PackageCardProps> = ({ item }: PackageCardProps) => (
	<div className="card-glow">
		<Link
			className="top-sales-card"
			to={`${SpecialDealURL}${item.specialsID}`}
			target="_blank"
		>
			<div
				className="top-sales-card__cover"
			>
				<Image
					src={item.imagePath ? `${CardImages}${item.imagePath}${item.imageName}` : `${DefaultCardImages}${item.image}`}
					fallback={fallback}
					alt="Card Cover"
				/>
			</div>

			<div className="top-sales-card__content">
				<div className="top-sales-card__supplier">
					<img
						src={item.supplierLogo}
						alt=""
					/>
				</div>

				<div className="top-sales-card__details">
					<div className="top-sales-card__details__route text-size_regular">
						<div className="font-weight_bold">{item.countryCityEmb} to {item.countryCityDeb}</div>
						<div className="font-weight_regular">{item.ship}</div>
					</div>

					<div className="top-sales-card__details__bullets">
						<div className="top-sales-card__details__bullets__item">
							<img src={calendar} alt="" />
							<span className="mx-2">{item.saildate}</span>
						</div>

						<div className="top-sales-card__details__bullets__item">
							<img src={location} alt="" /> <span className="mx-2">{item.product}</span>
						</div>
					</div>

					<div className="top-sales-card__badge">
						<img
							src={batch}
							alt=""
						/>
					</div>
				</div>
			</div>
		</Link>
	</div>
);

interface OwnProps {
	items: Array<Package>;
}

export const TopPackages: React.FC<OwnProps> = (props: OwnProps) => (
	<PageSection
		alignHeader="center"
		header={(
			<span style={{ color: 'white', textAlign: 'center', textWrap: 'balance' }}>
				<span className="text-uppercase">Our top</span>
				<span className="text-header__highlight font-family_decorative font-weight_light"> Selling </span>
				Packages
			</span>
		)}
		footer={(
			<div className="top-sales-container">
				<div className="top-sales-container__card-list">
					{
						props.items.map((value: Package) => (
							<PackageCard
								item={value}
								key={value.specialsID}
							/>
						))
					}
				</div>

				<Button
					variant={ButtonVariant.Filled}
					action={ActionMode.InternalLink}
					link={SearchValuInclusiveUrl}
				>
					View {props.items[0]?.vipDealsCount} Exclusive Packages
				</Button>
			</div>
		)}
	>
		<img
			className="page-section__cover"
			src={background}
			alt=""
		/>
	</PageSection>
);
